import { useEffect, useState } from "react";
import { mastheadMeta, navItems } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/80"
          : "bg-background-50 border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="hidden md:flex items-center justify-between h-9 text-[11px] tracking-wide text-foreground-500 border-b border-dashed border-background-200/80">
          <span className="font-label">{mastheadMeta.date}</span>
          <span className="font-label">{mastheadMeta.edition} · {mastheadMeta.weather}</span>
        </div>

        <div className="flex items-center justify-between gap-4 py-3 md:py-4">
          <a href="#top" className="flex items-center gap-3 group">
            <span className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-lg md:text-xl font-heading font-bold">
              料
            </span>
            <h1 className="flex flex-col leading-none m-0">
              <span className="font-heading font-bold text-xl md:text-2xl tracking-tight text-foreground-950">
                黑料看料
              </span>
              <span className="hidden sm:block font-label text-[11px] tracking-[0.2em] text-foreground-500 mt-1">
                {mastheadMeta.slogan}
              </span>
            </h1>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="px-3.5 py-2 rounded-md text-sm font-label text-foreground-700 hover:text-primary-600 hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => setSearchOpen((v) => !v)}
              aria-label="搜索"
              className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300/70 text-foreground-600 hover:text-primary-600 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-base"></i>
            </button>
            <a
              href="#board"
              className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-flashlight-line"></i>
              提供线索
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="菜单"
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300/70 text-foreground-600 cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
            </button>
          </div>
        </div>

        {searchOpen && (
          <div className="pb-3">
            <div className="flex items-center gap-3 px-3.5 py-2.5 rounded-md bg-background-100 border border-background-200/80">
              <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
                <i className="ri-search-line text-sm"></i>
              </span>
              <input
                type="text"
                placeholder="搜索事件、合集或话题，例如「停摆档案」"
                className="flex-1 bg-transparent text-sm font-label text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
              />
              <span className="hidden sm:inline-block font-label text-[11px] text-foreground-400">
                回车检索
              </span>
            </div>
          </div>
        )}

        {menuOpen && (
          <nav className="lg:hidden pb-4 grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-3.5 py-2.5 rounded-md bg-background-100 text-sm font-label text-foreground-700 hover:text-primary-600 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}